import { State } from '../apps/appCreator/store';

const getCreditCalcSelectedProgramm = (state: State) => {
  const { credits } = state.creditCalc.formState || {};
  let result: { [K: string]: any } = {
    isDisabledSuzukiFinance: true,
  };

  if (!credits) {
    return result;
  }

  const { current, credits: listCredits } = credits;

  if (!current) {
    return result;
  }
  const currentProgramm = listCredits.find(({ id }) => id === current);
  const creditTags = currentProgramm?.tags || [];

  const isDisabledSuzukiFinance = creditTags.includes(
    'disableDiscount:SuzukiFinance'
  );

  result = {
    ...currentProgramm,
    current,
    isDisabledSuzukiFinance,
  };

  return result;
};

export default getCreditCalcSelectedProgramm;
